import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

const AddUpdateLocationPrimaryUsageModal = ({ onClose, refetch, primaryUsageId = null, initialData = null }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Form state
  const [formData, setFormData] = useState({
    primaryUsageName: initialData?.primary_uage || '',
  });

  const validate = (values) => {
    const newErrors = {};

    // Primary Usage Name validation
    if (!values.primaryUsageName.trim()) {
      newErrors.primaryUsageName = 'Primary usage name is required';
    } else if (values.primaryUsageName.length < 2) {
      newErrors.primaryUsageName = 'Primary usage name must be at least 2 characters';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        primaryUsageId: primaryUsageId || 0,
        ...formData
      };
      const response = await api.post('/admin/CreateUpdateLocationPrimaryUsage', payload);
      if (response.data.status === '200') {
        dispatch(showNotification({
          message: response.data.message,
          type: "success"
        }));
        onClose();
        refetch?.();
      } else {
        setErrors(prev => ({
          ...prev,
          general: response.data.message || 'Something went wrong'
        }));
      }
    } catch (error) {
      setErrors({ submit: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <Card className="w-full mx-auto">
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="primaryUsageName" className="text-sm font-medium">
              Primary Usage Name
            </label>
            <TextField
              size="small"
              id="primaryUsageName"
              name="primaryUsageName"
              value={formData.primaryUsageName}
              onChange={handleInputChange}
              placeholder="Enter primary usage name"
              disabled={isSubmitting}
              error={Boolean(errors.primaryUsageName)}
              className={'w-full'}
            />
            {errors.primaryUsageName && (
              <p className="text-sm text-red-500 mt-1">{errors.primaryUsageName}</p>
            )}
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <CustomButton
              className="bg-gray-500 hover:bg-gray-700 text-white"
              text="Cancel"
              click={onClose}
            />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white"
              text={primaryUsageId ? "Update" : "Submit"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default AddUpdateLocationPrimaryUsageModal;